import { type Scope, createContextScope } from '@radix-ui/react-context'

import type {
  SwitchContext,
  SwitchProps,
  SwitchScopedProps,
} from './switch.types'

import { SwitchLabel } from './components/switch-label'
import { SwitchRefresh } from './components/switch-refresh'
import { SwitchThumb } from './components/switch-thumb'
import { SwitchToggle } from './components/switch-toggle'
import { SwitchRootVariants } from './switch.styles'

export const DISPLAY_NAME = 'Switch'

type SwitchRootProps = SwitchProps & {
  children: React.ReactNode
}

const SwitchRoot = (props: SwitchRootProps) => {
  const {
    disabled = false,
    loading = false,
    children,
    __scopeSwitch,
    ...rest
  } = props as SwitchScopedProps<SwitchRootProps>

  return (
    <SwitchProvider
      {...rest}
      disabled={disabled}
      loading={loading}
      scope={__scopeSwitch}
    >
      <div className={SwitchRootVariants()} data-testid="switch-root">
        {children}
      </div>
    </SwitchProvider>
  )
}

const [createSwitchContext] = createContextScope(DISPLAY_NAME)

export const [SwitchProvider, useSwitchContext]: readonly [
  ProviderType<SwitchContext>,
  (consumerName: string, scope: Scope) => SwitchContext,
] = createSwitchContext<SwitchContext>(DISPLAY_NAME)

/*
----------------------------------------------------------------
Composition Export
----------------------------------------------------------------
*/

export const Switch = {
  Root: SwitchRoot,
  Toggle: SwitchToggle,
  Thumb: SwitchThumb,
  Label: SwitchLabel,
  Refresh: SwitchRefresh,
}
